import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Box, Flex, Text } from 'components'
import Radio from 'components/RadioBox'
import Button from 'components/Buttons/Button'

import { LeadDetail } from 'store/types/lead'
import { colors } from 'utils/colors'
import useLeadDataConfig from '../../hooks/use-lead-data-config'

type MasterLeadBoxProps = {
  leadData: Partial<LeadDetail>
  isSelected?: boolean
  onChange: (leadId: string) => void
  hasSelectedMaster: boolean
}

export const MasterLeadBox = ({ isSelected, leadData, hasSelectedMaster, onChange }: MasterLeadBoxProps) => {
  const [borderColor, setBorderColor] = useState(colors.gray3)
  const { columns } = useLeadDataConfig()

  useEffect(() => {
    if (isSelected) {
      setBorderColor(colors.blue1)
    } else {
      setBorderColor(colors.gray3)
    }
  }, [isSelected])

  return (
    <Box borderRadius={'8px'} width={'406px'} overflow={'hidden'} border={`1px solid ${borderColor}`}>
      <MasterHeaderFlex
        gap="8px"
        backgroundColor="gray1"
        padding="12px 16px"
        borderBottom={`1px solid ${borderColor}`}
        justifyContent="flex-start"
        alignItems="center"
        height="50px"
        cursor="pointer"
        isSelected={Boolean(isSelected)}
        onClick={() => onChange(leadData?.leadId || '')}
      >
        <Box onClick={(e) => e.stopPropagation()}>
          <Radio selected={isSelected} onChange={() => onChange(leadData?.leadId || '')} />
        </Box>
        {hasSelectedMaster ? (
          isSelected ? (
            <Text fontSize={'14px'}>
              <MasterRecordButton size="small">master_record</MasterRecordButton>
            </Text>
          ) : (
            <Text fontSize={'14px'}>this_lead_will_be_deleted</Text>
          )
        ) : (
          <Text fontSize={'14px'}>select_master_record_lbl</Text>
        )}
      </MasterHeaderFlex>
      <MasterContentBox padding={'12px 16px'} minHeight={100} isSelected={Boolean(isSelected)}>
        <table
          style={{
            width: '100%',
          }}
        >
          <tbody>
            {columns.map((config, index) => {
              let displayValue: any

              if (config.accessor) {
                displayValue = config.accessor(leadData)
              } else {
                displayValue = leadData[config.key as keyof LeadDetail]
              }

              if (config.render) {
                displayValue = config.render(displayValue, leadData)
              } else {
                displayValue = <Text fontSize={'14px'}>{displayValue || ''}</Text>
              }

              return (
                <tr key={index}>
                  <td>
                    <Text marginRight={'17px'} color="gray6" lineHeight={'33px'} fontSize={'14px'}>
                      {config.title}
                    </Text>
                  </td>
                  <td style={{ marginLeft: '10px', verticalAlign: 'middle' }}>{displayValue}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </MasterContentBox>
    </Box>
  )
}

const MasterRecordButton = styled(Button)`
  height: 24px;
`

const MasterHeaderFlex = styled(Flex)<{ isSelected: boolean }>`
  background-color: ${({ isSelected }) => (isSelected ? '#E0E9FE' : 'transparent')};
`

const MasterContentBox = styled(Box)<{ isSelected: boolean }>`
  background-color: ${({ isSelected }) => (isSelected ? 'rgba(224, 233, 254, 0.2)' : 'transparent')};
`
